export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14235.36532a5c.jpg";